<template id="login">
    <div style="height: 100vh; overflow: auto; background: #ffffff; padding: 15px;font-family: 'Roboto', 'Noto', sans-serif;" >
        <div v-if="showLoginBox===true" style="padding: 25% 0">
            <div style="text-align: center">
                <div>
                    <img alt="quiz-image" src="../assets/hamropatro.png"
                         style="width: 100px;height: 100px; box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)"/>
                </div>
                <br>
                <p style="font-size: 16px; color:#797171; padding: 5px 12px"> {{text.loginText}}</p>
            </div>
            <br>
            <div>
                <div class="signInwrapper google" @click="!loginStarted ? login('g') : ''">
                    <img alt="quiz-image" src="../assets/google.png"
                         style="width: 17px;height: 17px; vertical-align: middle"/><span style="vertical-align: middle"> &nbsp;&nbsp;Sign in with Google</span>
                </div>
                <br>
                <div class="signInwrapper facebook" @click="!loginStarted ?login('f') : ''">
                    <i class="fa fa-facebook fa-fw"></i><span style="vertical-align: middle"> &nbsp;&nbsp;Sign in with Facebook</span>
                </div>
                <br>
                <div class="signInwrapper twitter" @click="!loginStarted ? login('t'): ''">
                    <i class="fa fa-twitter fa-fw"></i><span style="vertical-align: middle"> &nbsp;&nbsp;Sign in with Twitter</span>
                </div>
            </div>
        </div>
        <div v-else style="padding: 25% 0">
            <div style="text-align: center">
                <div>
                    <img alt="quiz-image" src="../assets/hamropatro.png"
                         style="width: 100px;height: 100px; box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)"/>
                </div>
                <br>
                <p style="font-size: 16px; color:#797171; padding: 5px 12px"> {{text.somethingWentWrong}}.</p>
            </div>
            <div>
                <div class="signInwrapper retry" @click="refresh()">
                    <v-ons-toolbar-button class="refresh"></v-ons-toolbar-button>
                    <span style="vertical-align: middle"> &nbsp;&nbsp;{{text.tryAgain}}</span>
                </div>
                <br>
                <div class="text-center">
                    <p style="font-size: 11px; color:#797171; padding: 15px 0">If you are getting error <a><span @click="logout()">Try Re-Login</span></a></p>
                </div>
            </div>
        </div>
        <div v-if="buttonClicked" class="text-center">
            <v-ons-progress-circular class="refreshButton circularPad" indeterminate
                                     value="100"></v-ons-progress-circular>
            <p style="font-size: 16px; color:#797171; padding: 5px 12px"> {{text.pleaseWait}}...</p>
        </div>
    </div>

</template>

<script>
    // import { user_authentication} from '../util/user_authentication';
    import globalConfig, {isLogin} from '../util/globalConfig'
    import usedText from "../util/languageText";
    import { Miniapp } from '../util/Miniapp';

    export default {
        data: () => ({
            showLoginBox: null,
            buttonClicked:null,
            loginStarted:false,
            text:usedText
        }),
        created() {
            if (sessionStorage.getItem("loginStarted")) {
                this.buttonClicked=true;
                this.showLoginBox = true;
                let self = this;
                setTimeout(() => {
                    if (localStorage.getItem(globalConfig.appId + '_user') !==null) {
                        self.showLoginBox = true;
                        self.buttonClicked=false;
                        const search = window.location.search;
                        if (search && search !== '') {
                            const searchedParameters = new URLSearchParams(search);
                            const redirectTo = searchedParameters.get('redirectURL');
                            if (redirectTo && redirectTo !== '') {
                                self.$router.push(redirectTo);
                            }
                        } else window.location.href = '/quiz';
                    } else {
                        self.showLoginBox = true;
                        self.buttonClicked=false;
                    }
                },10000)
            } else {
                this.showLoginBox = true
            }
        },
        methods: {
            login(type) {
                // localStorage.setItem(globalConfig.appId + '_quiz_role', 'quizPlayer');
                sessionStorage.setItem("loginStarted", "true");
                this.buttonClicked=true;
                this.loginStarted=true;
                let self = this;

               Miniapp.login().then(function (res) { 
                    console.log("mini app logged in successfully : ", res);
                    self.buttonClicked = false;
                    if(res) {
                        window.location = "/quiz";
                    }
               }).catch(function (err) { 

               });
            },
            refresh () {
                window.location.reload();
            },
            logout() {
                // user_authentication();
                Miniapp.logout();
            }
        },
    };
</script>